import React from 'react';
import {
	FormattedNumber,
} from 'react-intl';

import MissingValue from '~/components/app/MissingValue';



type Props = {
	maximumFractionDigits?: number,
	minimumFractionDigits?: number,
	value: number | null,
};

const PercentageFormatter: React.FC<Props> = (props) => {
	const {
		maximumFractionDigits,
		minimumFractionDigits,
		value = null,
	} = props;

	if (value === null) {
		return (
			<MissingValue ellipsis={true} />
		);
	}

	return (
		<FormattedNumber
			maximumFractionDigits={maximumFractionDigits}
			minimumFractionDigits={minimumFractionDigits}
			style="percent"
			value={value / 100}
		/>
	);
};



export default React.memo(PercentageFormatter);
